import { Component, AfterViewInit, OnInit, ChangeDetectorRef, ElementRef, ViewChild, Renderer } from '@angular/core';
// import { Component, OnInit,ElementRef,ViewChild,Directive,Renderer,AfterViewInit} from '@angular/core';

import {Title } from '@angular/platform-browser';
import { MdSnackBar } from '@angular/material';

import { TdLoadingService, TdDialogService, TdMediaService } from '@covalent/core';

import { StorageService } from '../../services/storage.service';
import { RestService } from '../../services/rest.service';

import 'rxjs/add/operator/toPromise';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';


@Component({
  selector: 'importCH',
  providers: [StorageService, RestService],
  templateUrl: './importCH.component.html',
  styleUrls: ['./importCH.component.scss']
})
export class ImportCHComponent implements AfterViewInit, OnInit {

  parcelCode: string;
  scannedValue: string;
  private storage: any = null;
  storages: any[] = [];
  private container: any = null;
  loadedParcel: boolean = false;
  containerName: string;
  loadedContainer: boolean = false;
  status: string;
  private order: any = null;

  filterTitle: string;

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    private _storageService: StorageService,
    private _restService: RestService,
    private _router: Router,
    private _dialogService: TdDialogService,
    private _snackBarService: MdSnackBar,
    private _changeDetectorRef: ChangeDetectorRef,
    public media: TdMediaService,
    public renderer: Renderer,private el:ElementRef) {
  }

  @ViewChild('ft01') infocus: ElementRef;

  ngOnInit(): void {
    this._titleService.setTitle('Import CH');
    //this.loadFilter('ALL', 'All parcels in storage');
    this.load();
  }

  loadFilter(filterTitle: string) {
    this.filterTitle = filterTitle;
  }

  ngAfterViewInit(): void {
    // broadcast to all listener observables when loading the page
    this.media.broadcast();
    // force a new change detection cycle since change detections
    // have finished when `ngAfterViewInit` is executed
    this._changeDetectorRef.detectChanges();
  }

  async load(): Promise<void> {
    try {
      this._loadingService.register('importCH.list');
      this.loadFilter('All importCH');    
    } catch (error) {

    } finally {
      this._loadingService.resolve('importCH.list');
    }
  }

  async loadParcelStatus(reference: string): Promise<void> {
    try {
      // get status from storage service: TAXATION, ECOMM_ARRIVE, ECOMM_RETURN, ECOMM_COMPLETE, ECOMM_DONE or READY_TO_SHIP
      // get info from storage service
      // if record found and container name not empty and itemCount > 0 => ask if we want to add second parcel
      // if record found and storage place empty 
      // if itemCount = 0 => OK we can store
      // if itemCount > 0 => This is a returning item
      this.parcelCode = reference;
      this.storages = await this._storageService.getParcel(reference).toPromise();
      this.storage = this.storages[0]; // for normal ch einlagern we assume we only get one order
      if (this.storage && this.storage.containerName && this.storage.itemCount > 0) {
        this.status = 'stored';
        this.loadContainer(this.storage.containerName, false);
      } else if (this.storage && !this.storage.containerName) {
        if (this.storage.itemCount == 0) { // not stored yet
          this.status = 'none';
        } else if (this.storage.itemCount > 0 && this.storage.workflowStatus == 'READY_TO_SHIP') { // already sent out
          this.status = 'returning';
        }
      }
      await this.getParcelDetails(this.storage.businessKey);
      this.loadedParcel = true;
    } catch (error) {
      this.status = 'nodata';
      this.loadedParcel = false;
    } finally {
    }
  }

  async getParcelDetails(businessKey: string): Promise<void> {
    try{
        let orderList = await this._storageService.getDetailsByBusinessKeyReader(businessKey).toPromise();
        if (orderList) {this.order = orderList[0];}
    } catch (error) {
        console.log('Cannot get order details!');
        this.storage = null;
    } finally {
    }
  }
  
  async loadContainer(containerName: string, process: boolean) {
    try {
      //validate container: it must exist
      this.container = await this._storageService.getContainer(containerName).toPromise();
      if (this.container.containerStatus == 'OPEN') {
        this.loadedContainer = true;
        if (process) {
          if (this.getStatus() == 'nodata') { // parcel does not exist
            this._dialogService.openAlert({ message: 'Parcel does not exist! Parcel will not be stored'});
            this.loadedContainer = false;
          } else if (this.getStatus() == 'stored') { // add parcel (already stored)
            this.addParcel()
          } else { // store parcel
            this.save();
          }
        }
      } else {
        this._dialogService.openAlert({ message: 'Container in wrong status!: ' + this.container.containerStatus });
        this.loadedContainer = false;
      }
    } catch (error) {
      //container does not exist
      this._dialogService.openAlert({ message: 'Container does not exist!'});
      this.loadedContainer = false;
    } finally {
    }
  }

  getStatus() {
    return this.status;
  }

  keytab(event, to: string){
    if (to == 'Enter container name') {
      this.loadParcelStatus(this.scannedValue);
    } else if (to == 'Submit') {
      this.loadContainer(this.containerName, true);
      to = 'Scan parcel'; // move cursor to Scan parcel at the end
    }

    let path = event.composedPath();

    let element = path[5]; // naviagte to md-card-content 

    let child;

      for (let j = 0; j < element.children.length; j++) {
        if (element.children[j].innerText == to) { // navigate to md-input-container with the given text
          child = element.children[j].children[0].children[0].children[0].children[0]; // navigate to input area where value is entered
        }
      }

    if(child == null)  // check if its null
        return;
    else
      child.focus();   // focus if not null
        return;
  }
  
  async save(): Promise<void> {
    try {
      this._loadingService.register('storeItem.load');
      let storageEvent = null;
      if (this.container) {
        if (this.status == 'none') {
          if (this.storage.workflowStatus == 'TAXATION' && this.container.name != 'WAGEN') { // if not sent to clearance scan always to WAGEN!!
            this._dialogService.openAlert({ message: 'You must store this parcel to WAGEN!' });
            this.container = null;
            this.containerName = null;
          } else {
            storageEvent = 'ARRIVED_HUB';
          }
        } else if (this.status == 'returning') {
          storageEvent = 'RETURNING_ITEM';
        }
        if (storageEvent) {
          let storage = {
            itemCount: 1,
            containerName: this.container.name,
            reference: this.storage.reference,
            storeUser: null,
            storeDate: new Date(),
            businessKey: this.storage.businessKey,
            projectId: this.storage.projectId
          }
          this.storage = await this._storageService.updateStorage(storage, storageEvent).toPromise();
          this.clearForm();
        }
      } else if (!this.container) {
        this._dialogService.openAlert({ message: 'Create container or shelf first!' });
      }
    } catch (error) {
      this._dialogService.openAlert({ message: 'Store parcel failed' });
    } finally {
      this._loadingService.resolve('storeItem.load');
    }
  }

  goBack(): void {
    this.clearForm();
    this._router.navigate(['/stockup/CH']);
  }

  clearForm() {
    this.scannedValue = '';
    this.containerName = null;
    //this.storage = null;
    this.container = null;
    this.status = null;
  }

  
  async addParcel() {
    try {
        this._loadingService.register('addItem.load');
        let storage = {
          itemCount: this.storage.itemCount + 1,
          containerName: this.container.name,
          reference: this.storage.reference,
          storeUser: null,
          storeDate: new Date(),
          businessKey: this.storage.businessKey,
          projectId: this.storage.projectId
        }
        this.storage = await this._storageService.updateStorage(storage, 'ARRIVED_HUB').toPromise();
        this.clearForm();
    } catch (error) {
      this._dialogService.openAlert({ message: 'Add parcel failed' });
    } finally {
      this._loadingService.resolve('addItem.load');
    }
  }

  sendEmail(parcelCode: string): void {
    this._dialogService
      .openConfirm({message: 'Send info email?'})
      .afterClosed().toPromise().then((confirm: boolean) => {
        if (confirm) {
          this._sendEmail(parcelCode);
        }
      });
  }

  private async _sendEmail(parcelCode: string): Promise<void> {
    try {
      this._loadingService.register('send.email');
        let jenkinsRequest = {
          jobName: 'storage-info-mail',
          jobParameters: []
        }
        jenkinsRequest.jobParameters.push({key: 'InfoEmail', value: environment.InfoEmail});
        if (this.getStatus() == 'nodata') {
          jenkinsRequest.jobParameters.push({key: 'Subject', value: 'Storage item ' + parcelCode + ' NOT FOUND!'});
          jenkinsRequest.jobParameters.push({key: 'Body', value: 'Not possible to store this item ' + parcelCode});
        } else if (this.getStatus() == 'returning') {
          jenkinsRequest.jobParameters.push({key: 'Subject', value: 'Storage item ' + parcelCode + ' RETURNING!'});
          jenkinsRequest.jobParameters.push({key: 'Body', value: 'This is a returning item! ' + parcelCode});
        }
        await this._restService.sendEmail(jenkinsRequest).toPromise();
        this._snackBarService.open('Email sent', 'Ok');
    } catch (error) {
      this._dialogService.openAlert({ message: 'Email not sent!' });
    } finally {
      this._loadingService.resolve('send.email');
    }
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/import/importCH/importCH.component.ts